/**
 * createScoreboardHudController — Thin DOM binding for mid-match scoreboard (SPY-41).
 * Presentation only: no combat formulas; rows come from getRows().
 */

function escapeText(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function rowHtml(row) {
  return (
    `<tr data-player-id="${escapeText(row.id)}">` +
    `<td style="padding:6px;">${escapeText(row.team)}</td>` +
    `<td style="padding:6px;">${escapeText(row.champion)}</td>` +
    `<td style="padding:6px;">${escapeText(row.level)}</td>` +
    `<td style="padding:6px;">${escapeText(row.kda)}</td>` +
    `<td style="padding:6px;">${escapeText(row.cs)}</td>` +
    `<td style="padding:6px;">${escapeText(row.gold)}</td>` +
    `</tr>`
  );
}

export function createScoreboardHudController({
  rootEl,
  tbodyEl,
  getRows
} = {}) {
  let visible = false;

  function render() {
    if (!tbodyEl) return [];
    const rows = typeof getRows === 'function' ? getRows() : [];
    const list = Array.isArray(rows) ? rows : [];
    tbodyEl.innerHTML = list.map(rowHtml).join('');
    return list;
  }

  function show() {
    const rows = render();
    if (rootEl) {
      rootEl.style.display = 'block';
      rootEl.setAttribute('aria-hidden', 'false');
    }
    visible = true;
    return rows;
  }

  function hide() {
    if (rootEl) {
      rootEl.style.display = 'none';
      rootEl.setAttribute('aria-hidden', 'true');
    }
    visible = false;
  }

  function toggle() {
    if (visible) {
      hide();
      return false;
    }
    show();
    return true;
  }

  function isVisible() {
    return visible;
  }

  function getSnapshot() {
    return typeof getRows === 'function' ? getRows() : [];
  }

  return { show, hide, toggle, render, isVisible, getSnapshot };
}
